<template>
<div class="footer">
      <div class="icones">
        <a href="https://agriculture.gouv.fr/ecophyto" target="_blank"><img  src="images/Logo_ecophyto2.png"></a>
        <a href="https://www.vignevin.com/wp-content/uploads/2019/03/Maitrise_de_la_qualite_de_la_pulve_NOTE_UMT_ECOTECHVITI.pdf" target="_blank"><img  src="images/Logo_UMT_ecotech_inrae.png"></a>
        <a href="https://www.vignevin.com/" target="_blank" ><img  src="images/ifv.png"></a>
        <a href="https://www.hdigitag.fr/fr/ " target="_blank"><img src="images/logoDigitAg-reserve.png" ></a>
        <a href="http://www.inrae.fr" target="_blank"><img src="images/logo_INRAE.png"></a>
      </div>
      <div class="copyright ">
        Copyright &copy; 2020-2025: <a href="https://inrae.fr" target="_blank">  www.inrae.fr </a> | <a href="https://www.hdigitag.fr/fr/" target="_blank"> www.hdigitag.fr</a> & <a  href="#/legalMentions" target="_blank"> {{$t('footer.legalMentions')}}</a>
      </div>
</div>
</template>

<script>
  export default {
    name: 'FooterComponent',
    components: {
    }
  }
</script>

<style scoped>

.footer {
  background-color: white;
  margin-top: 20px;
 
  bottom: 0;
  left: 0;
  right: 0;
}
.copyright{
  padding: 5px;
  text-align: center;
  font-size: 11px;
  height: 30px;
}

@media screen and (min-width: 1470px) {  

.icones{
  height: 70px;
  width: 100%;
}
.icones img {
  padding: 7px; 
  max-width: 6%;
  max-height: 70px;
}
}


@media screen and (max-width: 1470px) {
.icones{
  height: 70px;
}
.icones img {
  padding: 7px; 
  max-width: 9%;
  max-height: 70px;
}
}

</style>